import { withChartLayout } from 'components/common';
import SavedWounds from 'components/features/chart/wounds/saved-wounds/SavedWounds';

const SavedWoundsPage = withChartLayout('Saved Wounds Charting')(SavedWounds);
export default SavedWoundsPage;
